<template>
  <div class="AsistenciasPuntoSeleccionado">
    <md-table-card class="m-t-16">
      <md-card-header>
        <div class="md-title">{{turno.nombre_pun}}</div>
        <div class="md-subhead">{{ moment(turno.inicio_ptu,'h:mm:ss').format('h:mm A') }} - {{ moment(turno.termino_ptu,'h:mm:ss').format('h:mm A') }}</div>
      </md-card-header>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head># emp</md-table-head>
            <md-table-head>Empleado</md-table-head>
            <md-table-head>Teléfono</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="(e,index) in empleados" :key="index">
            <md-table-cell>
              <div v-if="e.id_emn">
                #{{e.id_emn}}
              </div>
            </md-table-cell>
            <md-table-cell>
              <div v-if="e.nombre">
                {{e.nombre}}
              </div>
              <div v-else>
                VACANTE
              </div>
            </md-table-cell>
            <md-table-cell>{{e.cel_emn}}</md-table-cell>
            <md-table-cell>
              <md-input-container>
                <label for="asistencia">Asistencia</label>
                <md-select name="asistencia" id="asistencia" @selected="asignarPaseLista(e.id_emn,$event)">
                  <md-option value="falta">Falta</md-option>
                  <md-option value="asistio">Asistió</md-option>
                  <md-option value="falta_just_pnh">Falta justificada</md-option>
                  <md-option value="falta_injust_pnh">Falta injustificada</md-option>
                  <md-option value="permiso_pnh">Permiso</md-option>
                  <md-option value="permiso_falle_pnh">Permiso fallecimiento</md-option>
                  <md-option value="permiso_naci_pnh">Permiso nacimiento</md-option>
                  <md-option value="hora_tie_ext_pnh">Hora(s) extra(s)</md-option>
                </md-select>
              </md-input-container>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
      <md-card-actions>
        <md-button class="md-raised md-primary" @click.native="abrirModal('confirmarPaseListas')">Guardar</md-button>
      </md-card-actions>
    </md-table-card>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="confirmarPaseListas">
      <md-dialog-title>¿Esta seguro de guardar el pase de lista?</md-dialog-title>
      <md-dialog-content>
        <p>Una vez guardado, este no podrá ser modificado.</p>
        <p>Recuerde, si no se indicó la asistencia de un empleado, será considerado como falta injustificada.</p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('confirmarPaseListas')">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click.native="guardarPaseDeLista()">Guardar pase de lista</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "AsistenciasPuntoSeleccionado",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal(ref) {
      this.$refs[ref].close();
    },
    obtenerEmpleadosPaseDeLista() {
      this.$http
        .post("asistencias/turno", {
          token: this.$session.get("token"),
          turno: this.$route.params.turno
        })
        .then(
          response => {
            if (response.status === 200 && "turno" in response.body) {
              this.turno = response.body.turno;
              this.empleados = response.body.empleados;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
              this.$router.push("/asistencias");
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    asignarPaseLista(empleado, evento) {
      this.asistencias[empleado] = evento;
    },
    guardarPaseDeLista() {
      this.$http
        .post("asistencias/guardar", {
          token: this.$session.get("token"),
          turno: this.turno.id_ptu,
          pase: this.asistencias,
          empleados: this.empleados
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right"
              });
              this.$router.push("/asistencias");
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    }
  },
  created() {
    this.obtenerEmpleadosPaseDeLista();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      msg: "Inicio",
      autocompleteValue: null,
      empleados: [],
      asistencias: [],
      turno: {
        nombre_pun: null,
        inicio_ptu: null,
        termino_ptu: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// AsistenciasPuntoSeleccionado.vue?6263841a